<label *ngIf="label && leftAlignLabel">{{label}}</label>
<div class="input-field" [class.invalid]="hasError">
    <input [(ngModel)]="value"
           [placeholder]="placeholder"
           [disabled] = "isDisabled"
           type="password">
    <label class="active"
           *ngIf="label && !leftAlignLabel">{{label}}</label>
    <app-form-error-list *ngIf="showErrors"
                         [errorMap]="formControl.errors"></app-form-error-list>
</div>
